import { sharedEffects } from 'shared-lib'
import * as applicationEffects from './application/application.effects'
import * as jobEffects from './job/job.effects'
import * as profileEffects from './profile/profile.effects'
import * as resumeEffects from './resume/resume.effects'
import * as videoEffects from './video/video.effects'

export const effects = { ...jobEffects, ...profileEffects, ...resumeEffects, ...videoEffects, ...applicationEffects, ...sharedEffects }
